import React, { FC, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  Button,
  Modal,
  Row,
  Col,
  Dropdown,
  Menu,
  Switch,
  Radio,
} from "antd";
import {
  SearchOutlined,
  EllipsisOutlined,
  ConsoleSqlOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_PAGE,
  GET_USERS_LIST,
  GET_ALL_FRIEND_PAGE,
  GET_ADMIN_GROUPS,
  GET_ADMIN_GROUP_MEMBERS,
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
  getMessageRequestPayload,
} from "../../helpers/request/RequestPayload";
import AddGroupModal from "components/Modals/AddGroupModal";
import InvitePeopleModal from "components/Modals/InvitePeopleModal";

import useLocalStorageService from "../../services/localStorage";
import { SocketTopics } from "../../constants/enums";
import { CID, UUID, RID } from "../../constants/localStoreKeys";
import { ReactSVG } from "react-svg";

import {
  getModifyPageSubscriptionTopic,
  getMembersRemoveFromPagePublishTopic,
} from "hooks/MQTTConstants";

import { generateUUID } from "utils/appUtil";

let timeout: NodeJS.Timeout;

function formatUserFilterText(text) {
  var result = "";
  let comp = text
    .trim()
    .split(" ")
    .filter((word) => word.length > 2)
    .map((x) => {
      return formatForRedis(x) + "*";
    });
  if (comp.length == 0) {
    return result;
  }

  comp.forEach((element) => {
    result += `@firstName:(${element})|@lastName:(${element})|`;
  });
  console.log("comp here", comp);
  result += `@beamIds:{${comp.join("|")}}`;

  return `(${result})`;
}

function formatForRedis(text) {
  return text.replace(/-|_|\./g, function (x) {
    return `\\${x}`;
  });
}

const PeopleModal: FC<{ onClose: () => void; socket?: ISocket }> = ({
  onClose,
  socket,
}) => {
  const { selectedItem, userSearchPage, friendPages, adminSearchGroup } =
    useSelector((state: RootState) => state.search);
  const { users, findUsersToPage, searchBds, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const scrollRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [groupModalOpen, setgroupModalOpen] = useState(false);
  const [inviteModalOpen, setinviteModalOpen] = useState(false);
  // const [allUsers, setAllUsers] = useState([]);
  // const [selectedUsers, setSelectedUsers] = useState<UserInfo[]>(
  const [selectedUsers, setSelectedUsers] = useState<any>({});
  const [selectedGroups, setSelectedGroups] = useState<any>({});

  const { projects } = useSelector((state: RootState) => state.dashboard);
  const [searchInput, setSearchInput] = useState("");
  const [groupSaving, setGroupSaving] = useState();
  const [selectedFilter, setSelectedFilter] = useState("people");
  const [groupMembersList, setGroupMembersList] = useState({});
  const { adminRoles } = useSelector((state: RootState) => state.dashboard);
  const { requestIds } = useSelector((state: RootState) => state.dashboard);


  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();

  const { getLocalStorageItem } = useLocalStorageService();

  // const searchUser = (inputQueryId: string, filterText?: string) => {
  //   let serviceId = "cudb-live";
  //   var searchQuery = `@userType:{user}@serviceId:{${formatForRedis(
  //     serviceId
  //   )}}`;
  //   if (filterText && filterText.length > 2) {
  //     searchQuery += formatUserFilterText(filterText);
  //   }
  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
  //       "CID"
  //     )}/service/bds/searchBds`,
  //     wrapRequestPayload({
  //       pagination: { offset: 0, limit: 100 },
  //       searchIndex: "beamdev:userNameIndex",
  //       searchQuery: searchQuery,
  //       searchOptions: "SORTBY beamIds ASC",
  //       inputQueryId,
  //     })
  //   );
  // };

  const aggregateUser = (inputQueryId: string, filterText?: string) => {
    var searchQuery = `@userType:{user}`;
    console.log('filter text', filterText);
    if (filterText && filterText.length > 2) {
      searchQuery += formatUserFilterText(filterText);
    }
    console.log('search query', searchQuery);
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
        "CID"
      )}/service/bds/aggregateBds`,
      wrapRequestPayload({
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status"
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      }, requestIds.user)
    );
  };

  useEffect(() => {
    if (selectedItem) {
      const orgGroups =
        selectedItem?.persistent?.static?.metadata?.members?.orgGroups || {};
      const users =
        selectedItem?.persistent?.static?.metadata?.members?.users || {};
      const orgUsersSet = new Set([]);
      Object.keys(orgGroups)?.map((group) => {
        orgGroups[group].userIds.map((user) => {
          orgUsersSet.add(user);
        });
      });
      const orgUsersArray = Array.from(orgUsersSet);
      console.log("users here", users);
      console.log("org users here", orgUsersArray);

      orgUsersArray.map((user) => {
        if (users?.[user]?.role === "write") {
          delete users?.[user];
        }
      });

      setSelectedUsers(users);

      setSelectedGroups(orgGroups);

      setGroupSaving(undefined);

      // setSelectedUsers(
      //   selectedItem?.persistent?.static?.metadata?.members?.users || []
      // );

      // if (!findUsersToPage) {
      //   findUsers();
      // }
      dispatch(GET_PAGE({ payload: {} }));
      dispatch(GET_ALL_FRIEND_PAGE({ payload: {} }));

      // dispatch({
      //   type: "SEND_MESSAGE",
      //   payload: {
      //     message: '',
      //     type: "removeMessage",
      //     data: { messageId: "194582" },
      //   },
      // });
    }
  }, [selectedItem]);

  useEffect(() => {
    if (findUsersToPage) {
      aggregateUser(findUsersToPage.queryId);
    }
  }, [findUsersToPage]);

  useEffect(() => {
    if (userSearchPage) {
      console.log("user search page", userSearchPage);
    }
  }, [userSearchPage]);

  const sendPageUpdateEvent = (type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      getLocalStorageItem(CID),
      getLocalStorageItem(RID),
      selectedItem.pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(selectedItem.pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const addUser = (user) => {
    const users = { ...selectedUsers, [user.id]: { role: "write" } };
    let expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 1);
    const currentUser = allUsers?.find((obj) => obj.id === localStorage.getItem('RID'));

    setSelectedUsers(users);
    sendPageUpdateEvent("addPageMember", {
      userId: user.id,
      beamId: user.beamId || `${user.firstName}.${user.lastName}`,
      role: "write",
      pending: {
        invited: true,
        expiresAt: expiresAt.getTime(),
        invitedBy: currentUser?.beamId
      },
    });
    if (scrollRef) {
      scrollRef.current.scrollTop = 0;
    }
  };

  const addGroup = (page) => {
    setGroupSaving(page.organization.queryId);
    sendPageUpdateEvent("addAdminGroup", {
      queryId: page.organization.queryId,
      // userIds: Object.keys(page.members),
      name: page.title,
      defaultRole: "write",
    });
  };

  const addPage = (page) => {
    console.log("add group here", page);
    console.log("selected users here", selectedUsers);

    if (page?.organization?.queryId) {
      addGroup(page);
    } else {
      Object.keys(page.members).map((member) => {
        if (!Object.keys(selectedUsers).find((item) => item === member)) {
          addUser({
            id: member,
            beamId: page.members[member].beamId,
          });
          console.log("add user", {
            id: member,
            beamId: page.members[member].beamId,
          });
        }
      });
    }
  };

  const addAdminGroup = (page) => {
    console.log("get page members here", page);
    // setGroupSaving(page.objectId.toString());
    // dispatch(GET_ADMIN_GROUP_MEMBERS({ queryId: page.objectId.toString(), callback: (response)=>{
    //   console.log('callback response here', response)
    //   const members = {};
    //   response?.data?.list.map((user)=>{
    //     members[user.split(':')?.[2]] =  {};
    //     return user
    //   });
    //   addGroup({
    //     organization: {
    //       queryId: page.objectId.toString(),
    //     },
    //     members,
    //     title: page.name
    //   });
    // } }));

    addGroup({
      organization: {
        queryId: page.objectId.toString(),
      },
      members: {},
      title: page.info.name,
    });
  };

  const removePage = (page) => {
    setGroupSaving(page.queryId);
    sendPageUpdateEvent("removeAdminGroup", {
      queryId: page.queryId,
    });
  };

  const breakPage = (page) => {
    setGroupSaving(page.queryId);
    sendPageUpdateEvent("breakAdminGroup", {
      queryId: page.queryId,
    });
  };

  const getUser = (userObj) => {
    const user = allUsers?.find((obj) => obj.id === userObj.id);
    const role = adminRoles?.find((x) => {
      return x._id === user?.roleId;
    });
    return (
      <React.Fragment>
        <Col span={4}>
          <img
            src={
              user?.profileImage?.urls?.original?.url ??
              "/images/users/user.png"
            }
            width="45"
            height="45"
          />
        </Col>

        <Col span={13}>
          <h5>
            {user && user.beamId
              ? user.beamId
              : userObj?.beamId && userObj?.beamId !== ""
              ? userObj?.beamId
              : `user #${userObj.id}`}
          </h5>
          {/* <p>{user?.email ?? "-"}</p> */}
          <p>{role?.name ?? "-"}</p>
          <p>{user?.department ?? "-"}</p>
        </Col>
      </React.Fragment>
    );
  };

  const getUserObj = (userObj) => {
    const user = allUsers?.find((obj) => obj.id === userObj.id);
    const role = adminRoles?.find((x) => {
      return x._id === user?.roleId;
    });
    return {
      profileImage:
        user?.profileImage?.urls?.original?.url ?? "/images/users/user.png",
      beamId: user?.beamId
        ? user?.beamId
        : userObj?.beamId && userObj?.beamId !== ""
        ? userObj?.beamId
        : `user #${userObj.id}`,
      role: role?.name ?? "-",
      department: user?.department ?? "-",
    };
  };

  const getRole = (userObj) => {
    const role = adminRoles?.find((x) => {
      return x._id === userObj?.roleId;
    });
    return role?.name;
  };

  const removeUser = (user) => {
    delete selectedUsers[user];
    const users = { ...selectedUsers };
    setSelectedUsers(users);
    sendPageUpdateEvent("removePageMember", {
      userId: user,
    });
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getMembersRemoveFromPagePublishTopic(user),
      {
        pattern: getMembersRemoveFromPagePublishTopic(user),
        data: selectedItem.pageId,
      }
    );
    if (scrollRef) {
      scrollRef.current.scrollTop = 0;
    }
  };

  const getFriendUser = (members) => {
    const user = Object.keys(members).find((x) => {
      return x !== localStorage.getItem("RID");
    });
    const userObj = allUsers?.find((obj) => obj.id === user);
    return {
      id: user,
      beamId: userObj,
    };
  };

  // const menu = (
  //   <Menu>
  //     <Menu.Item key={1}>item 1</Menu.Item>
  //   </Menu>
  // );

  const editMenu = (id, user) => {
    // console.log("edit menu");
    // const groups =
    //   selectedItem?.persistent?.static?.metadata?.members?.groups ?? {};
    // const userGroups = [];
    // Object.keys(groups).map((groupName) => {
    //   if ((groups[groupName]?.userIds ?? []).indexOf(id) !== -1)
    //     userGroups.push(groupName);
    // });
    return (
      <div className="menu-container edit-menu ml-auto people-dropdown">
        <div className="menu-item">
          <Radio.Group
            defaultValue={user.role}
            onChange={(event) => {
              sendPageUpdateEvent("updatePageMemberRole", {
                userId: id,
                role: event.target.value,
              });
            }}
          >
            {["edit", "read", "write"].map((item) => (
              <Radio.Button value={item} key={item}>
                {item}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
        {/* <div
          className="menu-item"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
          }}
        >
          {Object.keys(groups).map((groupName, idx) => (
            <React.Fragment>
              <p style={{ color: "#fff" }}>{groupName}</p>{" "}
              <Switch
                defaultChecked={
                  userGroups.indexOf(groupName) !== -1 ? true : false
                }
                onChange={(checked) => {
                  sendPageUpdateEvent(
                    checked ? "addGroupMember" : "removeGroupMember",
                    {
                      userId: id,
                      group: groupName,
                    }
                  );
                }}
              />
            </React.Fragment>
          ))}
        </div> */}
      </div>
    );
  };

  const dynamicSort = (property) => {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  };

  const groupMembers = (users = {}) => {
    const userObjs = Object.keys(users).map((user) => {
      return getUserObj({ id: user });
    });
    userObjs.sort(dynamicSort("beamId"));
    return (
      <div className="group-menu-container edit-menu ml-auto people-dropdown">
        <div className="menu-item">
          <Row className="beam-modal">
            <Col span={24}>
              {userObjs.map((user, index) => (
                <Row key={index} className="person-item">
                  <React.Fragment>
                    <Col span={4}>
                      <img src={user.profileImage} width="45" height="45" />
                    </Col>

                    <Col span={13}>
                      <h5>{user.beamId}</h5>
                      {/* <p>{user?.email ?? "-"}</p> */}
                      <p>{user.role}</p>
                      <p>{user.department}</p>
                    </Col>
                  </React.Fragment>
                </Row>
              ))}
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={() => {}}
        onCancel={handleCancel}
        width="520px"
        className="beam-modal scrollable max-height-fix"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >
        <Row className="d-flex mt-1 mb-4">
          <Col>
            <h3>People</h3>
          </Col>
          {/* {selectedItem && selectedItem.currentUserRole === "edit" && (
            <Col>
            <Button
              className="beam-btn blue-btn cover"
              onClick={() => {
                setinviteModalOpen(true);
              }}
            >
              Invite external users
            </Button>
          </Col>
          )} */}
        </Row>

        {selectedItem && selectedItem.currentUserRole === "edit" && (
          <Row>
            <Col span={24}>
              <Input
                onChange={(e) => {
                  const value: string = e.target.value;
                  if(value === undefined || value === '')return;
                  if (timeout) clearTimeout(timeout);
                  timeout = setTimeout((search) => {
                    // dispatch(GET_USERS_LIST(value));
                    console.log('get user list', search);
                    if (findUsersToPage) {
                      aggregateUser(findUsersToPage?.queryId, search);
                    }
                    dispatch(GET_PAGE({ search: value }));
                    dispatch(
                      GET_ADMIN_GROUPS({
                        search: value,
                        serviceId: projects?.userServiceId,
                      })
                    );
                  }, 500, value);
                  setSearchInput(value);
                }}
                placeholder="Search for users or groups or pages"
                suffix={<SearchOutlined />}
              />
            </Col>

            <Col span={24} className="mt-3">
              <InvitePeopleModal
                socket={socket}
                onClose={() => {}}
                page={true}
              />
            </Col>
          </Row>
        )}
        <Row className="scrollable-body mt-4" ref={scrollRef}>
          <Col span={24}>
            <Row className="d-flex mb-4">
              <Col>
                <h5>On page</h5>
              </Col>
              <Col>
                <p>{selectedUsers.length || 0} person</p>
              </Col>
            </Row>
            {selectedUsers &&
              Object.keys(selectedUsers).map((member) => (
                <Row key={member} className="person-item">
                  {/* <Col span={4}>
                    <img src="/images/users/user.png" width="45" height="45" />
                  </Col> */}
                  {/* <Col span={13}> */}
                  {/* <h5>{`user# ${member}`}</h5> */}
                  {/* <p>{member.email || "-"}</p> */}
                  {/* <p>{member.phone || "-"}</p> */}
                  {/* </Col> */}

                  {getUser({ id: member, ...selectedUsers[member] })}
                  {selectedItem && selectedItem.currentUserRole === "edit" && (
                    <Col span={7} className="t-right">
                      <Button
                        className="beam-btn orange-btn"
                        onClick={() => removeUser(member)}
                      >
                        Remove
                      </Button>
                      <Dropdown
                        trigger={["click"]}
                        overlay={editMenu(member, selectedUsers[member])}
                        // overlay={menu}
                        className="message-dropdown"
                        placement="bottomRight"
                      >
                        <a
                          className="ant-dropdown-link"
                          onClick={(e) => e.preventDefault()}
                        >
                          <EllipsisOutlined />
                        </a>
                      </Dropdown>
                    </Col>
                  )}
                </Row>
              ))}

            {selectedGroups &&
              Object.keys(selectedGroups).map((group) => (
                <Row
                  className="person-item"
                  key={selectedGroups[group].queryId}
                >
                  <Col span={4}>
                    <ReactSVG
                      src={`/images/community-blue-icon.svg`}
                      className="colorable mark-icon"
                    />
                  </Col>
                  <Col span={10}>
                    <h5>{selectedGroups[group].name}</h5>
                  </Col>
                  <Col span={10} className="t-right d-flex">
                    {selectedItem && selectedItem.currentUserRole === "edit" && (
                      <React.Fragment>
                        <Button
                          loading={
                            groupSaving === selectedGroups[group].queryId
                          }
                          className="beam-btn orange-btn mr-2"
                          onClick={() => {
                            removePage(selectedGroups[group]);
                          }}
                        >
                          Remove
                        </Button>

                        <Button
                          loading={
                            groupSaving === selectedGroups[group].queryId
                          }
                          className="beam-btn green-btn"
                          onClick={() => {
                            breakPage(selectedGroups[group]);
                          }}
                        >
                          Break
                        </Button>

                        <Dropdown
                          trigger={["click"]}
                          onVisibleChange={(visible) => {
                            if (visible) {
                              const queryId = selectedGroups[group].queryId;
                              if (queryId) {
                                dispatch(
                                  GET_ADMIN_GROUP_MEMBERS({
                                    queryId,
                                    callback: (response) => {
                                      console.log(
                                        "callback response here",
                                        response
                                      );
                                      const members = {};
                                      response?.data?.list.map((user) => {
                                        if(user.split(":")?.[1] === 'user'){
                                          members[user.split(":")?.[2]] = {};
                                        }
                                        return user;
                                      });
                                      console.log("get page members", members);
                                      setGroupMembersList({
                                        ...groupMembersList,
                                        [selectedGroups[group].queryId]:
                                          members,
                                      });
                                    },
                                  })
                                );
                              }
                            }
                          }}
                          overlay={groupMembers(
                            groupMembersList?.[selectedGroups[group].queryId]
                          )}
                          // overlay={menu}
                          className="message-dropdown"
                          placement="bottomRight"
                        >
                          <a
                            className="ant-dropdown-link"
                            onClick={(e) => e.preventDefault()}
                          >
                            <EllipsisOutlined />
                          </a>
                        </Dropdown>
                      </React.Fragment>
                    )}
                  </Col>
                </Row>
              ))}

            {selectedItem && selectedItem.currentUserRole === "edit" && (
              <React.Fragment>
                <Row className="d-flex mt-4 mb-4">
                  <Col>
                    <h5>Add to page</h5>
                  </Col>
                  {/* {users && users.length > 0 && 
              <Col>
                <p>{users ? users.length : 0} people</p>
              </Col>
            } */}
                  {/* {(!users || users.length === 0) && selectedItem && selectedItem.currentUserRole === 'edit' && */}
                  {/* <Col>
                    <Button
                      className="beam-btn blue-btn cover"
                      onClick={() => {
                        setinviteModalOpen(true);
                      }}
                    >
                      Invite people
                    </Button>
                  </Col> */}
                  {/* } */}
                </Row>

                {/* {searchInput !== "" && ( */}
                  <React.Fragment>
                    <Row className="d-flex mb-4">
                      <Col span={4}>
                        <Button
                          onClick={() => {
                            setSelectedFilter("people");
                          }}
                          className={`beam-btn ${
                            selectedFilter === "people" ? "green-btn cover" : ""
                          }`}
                        >
                          People
                        </Button>
                      </Col>
                      <Col span={7}>
                        <Button
                          onClick={() => {
                            setSelectedFilter("admin");
                          }}
                          className={`beam-btn ${
                            selectedFilter === "admin" ? "green-btn cover" : ""
                          }`}
                        >
                          Groups
                        </Button>
                      </Col>
                      <Col span={7}>
                        <Button
                          onClick={() => {
                            setSelectedFilter("user");
                          }}
                          className={`beam-btn ${
                            selectedFilter === "user" ? "green-btn cover" : ""
                          }`}
                        >
                          Pages
                        </Button>
                      </Col>
                    </Row>
                  </React.Fragment>
                {/* )} */}

                {searchBds &&
                  searchInput !== "" &&
                  selectedFilter === "people" &&
                  searchBds.map(
                    (user, index) =>
                      !Object.keys(selectedUsers).find(
                        (item) => item === user.id
                      ) && (
                        <Row className="person-item" key={index}>
                          <Col span={5}>
                            <img
                              src={
                                user?.profileImage?.urls?.original?.url ??
                                `/images/users/user-1.png`
                              }
                              width="45"
                              height="45"
                            />
                          </Col>
                          <Col span={12}>
                            <h5>{user.beamId}</h5>
                            {/* <p>{user.email || "-"}</p> */}
                            <p>{getRole(user) || "-"}</p>
                            <p>{user.department || "-"}</p>
                          </Col>
                          <Col span={7} className="t-right">
                            {selectedItem &&
                              selectedItem.currentUserRole === "edit" && (
                                <React.Fragment>
                                  {Object.keys(selectedUsers).find(
                                    (item) => item === user.id
                                  ) ? (
                                    <Button
                                      className="beam-btn orange-btn mr-2"
                                      onClick={() => removeUser(user)}
                                    >
                                      Remove
                                    </Button>
                                  ) : (
                                    <Button
                                      className="beam-btn green-btn"
                                      onClick={() => addUser(user)}
                                    >
                                      Add
                                    </Button>
                                  )}
                                </React.Fragment>
                              )}
                          </Col>
                        </Row>
                      )
                  )}

                {friendPages &&
                  searchInput === "" &&
                  selectedFilter === "people" &&
                  friendPages
                    .filter((page) => {
                      return page.pageId !== selectedItem.pageId;
                    })
                    .map(
                      (page, index) =>
                        !Object.keys(selectedUsers).find(
                          (item) =>
                            item === getFriendUser(page.members).id ||
                            getFriendUser(page.members).id == undefined
                        ) && (
                          <Row className="person-item" key={page.pageId}>
                            {getUser(getFriendUser(page.members))}
                            <Col span={7} className="t-right">
                              {selectedItem &&
                                selectedItem.currentUserRole === "edit" && (
                                  <React.Fragment>
                                    <Button
                                      className="beam-btn green-btn"
                                      onClick={() => {
                                        addPage(page);
                                      }}
                                    >
                                      Add
                                    </Button>
                                  </React.Fragment>
                                )}
                            </Col>
                          </Row>
                        )
                    )}

                {searchInput === "" && (
                  <React.Fragment>


                    {userSearchPage &&
                    selectedFilter === "admin" &&
                      userSearchPage
                        .filter((page) => {
                          return (
                            page.pageId !== selectedItem.pageId &&
                            page.organization !== undefined
                          );
                        })
                        .map(
                          (page) =>
                            !Object.keys(selectedGroups).find(
                              (item) =>
                                selectedGroups[item]?.queryId ===
                                page.organization.queryId
                            ) && (
                              <Row className="person-item" key={page.pageId}>
                                <Col span={5}>
                                  <ReactSVG
                                    src={`/images/community-blue-icon.svg`}
                                    className="colorable mark-icon"
                                  />
                                </Col>
                                <Col span={12}>
                                  <h5>{page.title}</h5>
                                </Col>
                                <Col span={7} className="t-right">
                                  {selectedItem &&
                                    selectedItem.currentUserRole === "edit" && (
                                      <React.Fragment>
                                        <Button
                                          className="beam-btn green-btn"
                                          loading={
                                            groupSaving !== undefined &&
                                            groupSaving ===
                                              page?.organization?.queryId
                                          }
                                          onClick={() => {
                                            addPage(page);
                                          }}
                                        >
                                          Add group
                                        </Button>

                                        <Dropdown
                                          trigger={["click"]}
                                          onVisibleChange={(visible) => {
                                            if (visible) {
                                              const queryId =
                                                page?.organization?.queryId;
                                              if (queryId) {
                                                dispatch(
                                                  GET_ADMIN_GROUP_MEMBERS({
                                                    queryId,
                                                    callback: (response) => {
                                                      console.log(
                                                        "callback response here",
                                                        response
                                                      );
                                                      const members = {};
                                                      response?.data?.list.map(
                                                        (user) => {
                                                  
                                                          if(user.split(":")?.[1] === 'user'){
                                                            members[user.split(":")?.[2]] = {};
                                                          }
                                                          return user;
                                                        }
                                                      );
                                                      console.log(
                                                        "get page members",
                                                        members
                                                      );
                                                      setGroupMembersList({
                                                        ...groupMembersList,
                                                        [page?.organization
                                                          ?.queryId]: members,
                                                      });
                                                    },
                                                  })
                                                );
                                              }
                                            }
                                          }}
                                          overlay={groupMembers(
                                            groupMembersList?.[
                                              page?.organization?.queryId
                                            ]
                                          )}
                                          // overlay={menu}
                                          className="message-dropdown"
                                          placement="bottomRight"
                                        >
                                          <a
                                            className="ant-dropdown-link"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <EllipsisOutlined />
                                          </a>
                                        </Dropdown>
                                      </React.Fragment>
                                    )}
                                </Col>
                              </Row>
                            )
                        )}
                  </React.Fragment>
                )}

                {userSearchPage &&
                  (selectedFilter === "user") &&
                  userSearchPage
                    .filter((page) => {
                      return (
                        page.pageId !== selectedItem.pageId &&
                        page.organization === undefined
                      );
                    })
                    .map((page) => (
                      <Row className="person-item" key={page.pageId}>
                        <Col span={5}>
                          <ReactSVG
                            src={`/images/community-blue-icon.svg`}
                            className="colorable mark-icon"
                          />
                        </Col>
                        <Col span={12}>
                          <h5>{page.title}</h5>
                        </Col>
                        <Col span={7} className="t-right">
                          {selectedItem &&
                            selectedItem.currentUserRole === "edit" && (
                              <React.Fragment>
                                <Button
                                  className="beam-btn green-btn"
                                  loading={
                                    groupSaving !== undefined &&
                                    groupSaving === page?.organization?.queryId
                                  }
                                  onClick={() => {
                                    addPage(page);
                                  }}
                                >
                                  Add group
                                </Button>
                              </React.Fragment>
                            )}
                        </Col>
                      </Row>
                    ))}

                {adminSearchGroup &&
                  searchInput !== "" &&
                  selectedFilter === "admin" &&
                  adminSearchGroup
                    .filter((page) => {
                      return true;
                    })
                    .map(
                      (page) =>
                        !Object.keys(selectedGroups).find(
                          (item) =>
                            selectedGroups[item]?.queryId ===
                            page.objectId.toString()
                        ) && (
                          <Row className="person-item" key={page.objectId}>
                            <Col span={5}>
                              <ReactSVG
                                src={`/images/community-blue-icon.svg`}
                                className="colorable mark-icon"
                              />
                            </Col>
                            <Col span={12}>
                              <h5>{page.info.name}</h5>
                            </Col>
                            <Col span={7} className="t-right">
                              {selectedItem &&
                                selectedItem.currentUserRole === "edit" && (
                                  <React.Fragment>
                                    <Button
                                      className="beam-btn green-btn"
                                      loading={
                                        groupSaving !== undefined &&
                                        groupSaving === page.objectId.toString()
                                      }
                                      onClick={() => {
                                        addAdminGroup(page);
                                      }}
                                    >
                                      Add group
                                    </Button>

                                    <Dropdown
                                      trigger={["click"]}
                                      onVisibleChange={(visible) => {
                                        if (visible) {
                                          const queryId =
                                            page.objectId.toString();
                                          if (queryId) {
                                            dispatch(
                                              GET_ADMIN_GROUP_MEMBERS({
                                                queryId,
                                                callback: (response) => {
                                                  console.log(
                                                    "callback response here",
                                                    response
                                                  );
                                                  const members = {};
                                                  response?.data?.list.map(
                                                    (user) => {
                                                      if(user.split(":")?.[1] === 'user'){
                                                        members[user.split(":")?.[2]] = {};
                                                      }
                                                      return user;
                                                    }
                                                  );
                                                  console.log(
                                                    "get page members",
                                                    members
                                                  );
                                                  setGroupMembersList({
                                                    ...groupMembersList,
                                                    [page.objectId.toString()]:
                                                      members,
                                                  });
                                                },
                                              })
                                            );
                                          }
                                        }
                                      }}
                                      overlay={groupMembers(
                                        groupMembersList?.[
                                          page.objectId.toString()
                                        ]
                                      )}
                                      // overlay={menu}
                                      className="message-dropdown"
                                      placement="bottomRight"
                                    >
                                      <a
                                        className="ant-dropdown-link"
                                        onClick={(e) => e.preventDefault()}
                                      >
                                        <EllipsisOutlined />
                                      </a>
                                    </Dropdown>
                                  </React.Fragment>
                                )}
                            </Col>
                          </Row>
                        )
                    )}
              </React.Fragment>
            )}
          </Col>
        </Row>
      </Modal>
      {groupModalOpen && (
        <AddGroupModal
          socket={socket}
          onClose={() => setgroupModalOpen(false)}
        />
      )}
      {/* {inviteModalOpen && (
        <InvitePeopleModal
          socket={socket}
          onClose={() => setinviteModalOpen(false)}
        />
      )} */}
    </React.Fragment>
  );
};

export default PeopleModal;
